import axios, { AxiosInstance } from 'axios';
import { useAuthStore } from '../stores/auth';

export const api: AxiosInstance = axios.create({
  baseURL: '/',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Token expired or invalid — clear session and force a re-login.
      useAuthStore.getState().logout();
      if (window.location.pathname !== '/login') window.location.replace('/login');
    }
    return Promise.reject(err);
  },
);
